import FilterA from './FilterA.js'

export default function FilterPopup({Click,Close}) {
    return (
        <>
        <div class={Click ? 'FilterPopup-t' : 'FilterPopup-tF'}>
            <FilterA/>
        </div>
        <div class={Click ? 'FilterPopup-p' : 'FilterPopup-pF'}>
            <FilterA/>
        </div>
        <div class={Click ? 'PopupBackground' : 'PopupBackgroundF'} onClick={Close}/>
        </>
        )}